import * as React from "react"
import { type ClassValue } from "clsx"

import { cn } from "../../lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  leftIcon?: React.ReactElement<{ className?: string }>
  rightIcon?: React.ReactElement<{ className?: string }>
  leftIconClassName?: ClassValue
  rightIconClassName?: ClassValue
  wrapperClassName?: ClassValue
  error?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type = "text",
      leftIcon,
      rightIcon,
      leftIconClassName,
      rightIconClassName,
      wrapperClassName,
      error,
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn("relative m-[2px] w-full", wrapperClassName)}>
        {leftIcon &&
          React.cloneElement(leftIcon, {
            className: cn(
              "absolute left-[10px] top-1/2 -translate-y-1/2 size-4 peer-focus:text-gray-700",
              leftIconClassName
            ),
          } as React.HTMLAttributes<HTMLElement>)}
        <input
          className={cn(
            "outline-solid peer h-10 w-full rounded-md bg-gradient-to-b from-gray-50 to-white p-[10px] shadow-[inset_0px_2px_2px_0px] shadow-gray-100 outline outline-1 outline-offset-0 outline-gray-200 placeholder:text-gray-400 hover:from-gray-100 hover:to-gray-50 hover:shadow-[inset_0px_3px_2px_0px] hover:shadow-gray-200 hover:outline-primary-200 focus:from-gray-100 focus:to-gray-50 focus:shadow-[inset_0px_0px_2px_4px] focus:shadow-gray-200 focus:outline focus:outline-2 focus:outline-primary-500 focus:placeholder:text-transparent disabled:cursor-not-allowed disabled:bg-gray-200 disabled:bg-none disabled:shadow-[inset_0px_2px_2px_0px] disabled:shadow-gray-100 disabled:outline-gray-200",
            {
              "pl-[38px]": leftIcon,
              "pr-[38px]": rightIcon,
              "bg-gray-50 outline-error-500 hover:outline-error-500 focus:outline-error-500 disabled:outline-error-500":
                error,
            },
            className
          )}
          ref={ref}
          type={type}
          {...props}
        />
        {rightIcon &&
          React.cloneElement(rightIcon, {
            className: cn(
              "absolute right-[10px] top-1/2 -translate-y-1/2 size-4 peer-focus:text-inherit text-gray-400",
              rightIconClassName
            ),
          } as React.HTMLAttributes<HTMLElement>)}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
